import React from "react";
import { Typography, Grid } from "@material-ui/core";
import useStyles from "./styles";
import RemittanceGridRow from "./RemittanceGridRow/RemittanceGridRow";
import { useReportTerminationContext } from "./ReportTerminationContext";
import Dinero from "dinero.js";
import CurrencyInput from "react-currency-input";

const CalculatedFinalNetPayForm = () => {
  const [localState, setLocalState] = React.useState({
    finalNetPay: "",
    finalValue: Dinero({ amount: 0 }),
  });
  const { finalNetPay, finalValue } = localState;
  const classes = useStyles();
  const { state, dispatch } = useReportTerminationContext();

  const deductionAmountCents = Dinero({
    amount: state.deductionAmountCents || 0,
  });

  const calculateFinalValueInCents = (value: string) => {
    const payCheckMinusDeduction = Dinero({ amount: calculateGrossPayInCents(value) }).subtract(
      deductionAmountCents
    );
    return payCheckMinusDeduction.greaterThan(Dinero({ amount: 0 }))
      ? payCheckMinusDeduction
      : Dinero({ amount: 0 });
  };

  const calculateGrossPayInCents = (value: string) => value.includes(".") ? parseInt(value.replace(".", "")) : parseInt(value) * 100;

  const handleFinalNetPayChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value.replace("$", "");
    const finalValueInCents = calculateFinalValueInCents(value);
    setLocalState({ finalNetPay: value, finalValue: finalValueInCents });
    dispatch({
      type: "updateNetPay",
      grossPayCents: calculateGrossPayInCents(value),
      deductionAmountCents: deductionAmountCents.getAmount(),
      netPay: finalValueInCents.getAmount(),
    });
  };

  const finalNetPayInputRow = (
    <>
      <Grid item xs={6}>
        <Typography>Calculated final net pay</Typography>
      </Grid>
      <Grid item xs={6}>
        <CurrencyInput
          id="calculated-final-net-pay"
          value={finalNetPay}
          onChangeEvent={handleFinalNetPayChange}
          className={classes.calculatedFinalNetPayInput}
          prefix="$"
          thousandSeparator=""
        />
      </Grid>
    </>
  );

  const transfersAndFeesRow = (
    <>
      <Grid item xs={6}>
        <Typography>Outstanding DailyPay transfers and fees</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography>- ${deductionAmountCents.toFormat("0.00")}</Typography>
      </Grid>
    </>
  );

  const finalPaperCheckValueRow = (
    <>
      <Grid item xs={6}>
        <Typography>Final paper check value</Typography>
      </Grid>
      <Grid item xs={6} className={classes.transfersAndFeesResult}>
        <Typography id="final-paper-check-value">{`= $${finalValue.toFormat(
          "0.00"
        )}`}</Typography>
      </Grid>
    </>
  );

  return (
    <div className={classes.root}>
      <Grid container alignItems={"center"} spacing={2}>
        {finalNetPayInputRow}
        {transfersAndFeesRow}
        {finalPaperCheckValueRow}
        <RemittanceGridRow />
      </Grid>
    </div>
  );
};

export default CalculatedFinalNetPayForm;
